import { render, staticRenderFns } from "./MicrosoftLogoIcon.vue?vue&type=template&id=3c215828&"
import script from "./MicrosoftLogoIcon.vue?vue&type=script&lang=js&"
export * from "./MicrosoftLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports